import { useStores } from 'src/components/common/root-store-provider/root-store-provider';

export const useAbTestCaseName = (
  testName: string,
): string | null | undefined => {
  const {
    analyticsStore: { getCaseNameByTestName },
  } = useStores();

  const caseName = getCaseNameByTestName(testName);

  return caseName;
};
